var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3329 3.23487L5.25111 5.25124L3.23475 15.333C3.20247 15.4945 3.21053 15.6614 3.25824 15.8189C3.30595 15.9765 3.39182 16.1199 3.50823 16.2363L16.5648 29.2929C16.6577 29.3857 16.7679 29.4594 16.8892 29.5096C17.0106 29.5599 17.1406 29.5858 17.2719 29.5858C17.4033 29.5858 17.5333 29.5599 17.6546 29.5096C17.7759 29.4594 17.8862 29.3857 17.979 29.2929L29.2927 17.9792C29.3856 17.8863 29.4593 17.7761 29.5095 17.6547C29.5598 17.5334 29.5856 17.4034 29.5856 17.2721C29.5856 17.1407 29.5598 17.0107 29.5095 16.8894C29.4593 16.768 29.3856 16.6578 29.2927 16.5649L16.2361 3.50835C16.1197 3.39194 15.9764 3.30607 15.8188 3.25836C15.6613 3.21066 15.4944 3.20259 15.3329 3.23487V3.23487Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12C11.3284 12 12 11.3284 12 10.5C12 9.67157 11.3284 9 10.5 9C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.59ad308774c98d98f4fd73377a330af1.svg";
export { ForwardRef as ReactComponent };